module.exports = __webpack_public_path__ + "static/img/je.daa3c7a6.svg";